/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Missing_LabelInputs */

const en_orders_missing_label = /** @type {(inputs: Orders_Missing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing:`)
};

const es_orders_missing_label = /** @type {(inputs: Orders_Missing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`falta:`)
};

/**
* | output |
* | --- |
* | "missing:" |
*
* @param {Orders_Missing_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_missing_label = /** @type {((inputs?: Orders_Missing_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Missing_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_missing_label(inputs)
	return es_orders_missing_label(inputs)
});